// extracted by mini-css-extract-plugin
export var messageSideLeft = "_s8-1";
export var stateContainer = "_s8-0";